import React from 'react';

import { Skeleton } from 'src/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/components/ui/table';
import { forecastPaginatedTableMetricConfig } from 'src/features/forecastPaginated/forecastPaginatedTable/configs/forecastPaginatedTableMetricConfig';

export function ForecastPaginatedTableSkeleton() {
  const timeColumnsCount = 36;

  const skeletonMetrics = forecastPaginatedTableMetricConfig;
  return (
    <Table className='w-full table-fixed'>
      <TableHeader>
        <TableRow>
          <TableHead className='sticky left-0 z-10 h-14 w-44 border-r border-border-default bg-white pl-2 dark:bg-neutral-900' />

          {Array.from({ length: timeColumnsCount }).map((_, index) => (
            <TableHead
              key={index}
              className='relative size-14 border-r border-border-default text-center'
            >
              <div className='relative -ml-4 size-14 text-center'>
                <div className='absolute inset-0 flex items-center justify-center'>
                  <Skeleton className='h-3 w-8 origin-center -rotate-45 transform' />
                </div>
              </div>
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {skeletonMetrics.map((metric, rowIndex) => (
          <TableRow key={metric.key}>
            <TableCell
              className={`sticky left-0 z-10 h-14 w-44 border-r border-border-default bg-white pl-2 dark:bg-neutral-900 ${
                rowIndex % 2 !== 0 ? 'bg-card' : 'bg-card-lighter'
              }`}
            >
              <div className='flex items-center gap-2'>
                <div
                  className='size-1.5 rounded-full'
                  style={{ backgroundColor: metric.color }}
                />
                <Skeleton className='h-4 w-24' />
              </div>
            </TableCell>

            {Array.from({ length: timeColumnsCount }).map((_, colIndex) => (
              <TableCell
                key={colIndex}
                className={`relative size-14 border-r border-border-default text-center ${
                  rowIndex % 2 !== 0 ? 'bg-card' : 'bg-card-lighter'
                }`}
              >
                <Skeleton className='mx-auto h-4 w-12' />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
